<template>
  <PieChartCard
    :loading="loading"
    :label="$t('Status of issues')"
    :chart-data="chartData"
    @rowClick="handleClick"
    @chartClick="handleClick"
  >
    <i18n path="Status of {item}" tag="p" :dummy="$t('Status of {item}')">
      <template v-slot:item>
        <span class="font-semibold underline cursor-pointer" @click="$emit('click')">{{ $t('Issues') }}</span>
      </template>
    </i18n>
  </PieChartCard>
</template>

<script>
  import PieChartCard from '@/_legacy/views/Analytics/components/PieChartCard.vue';

  export default {
    components: { PieChartCard },
    props: {
      chartData: {
        type: Object,
        required: true,
      },
      loading: {
        type: Boolean,
        default: true,
      },
    },
    methods: {
      handleClick(meta) {
        this.$emit('rowClick', meta);
      },
    },
  };
</script>
